import * as React from "react";
import { Mad, User } from "../../graphql/types/base";
import { UserMadFragment } from "../../graphql/fragments";
import useTranslations from "../../hooks/useTranslations";
import { H4, Link } from "../wombat-ui";
import { FollowUpPlate } from "./FollowUpPlate";
import { concat, sortBy } from 'lodash';

type CollaboratorFollowUpsSectionProps = {
  user: UserMadFragment;
};

const getPlate: React.ReactNode = (mad: Mad, user: User) => {
  return (
    <Link
      className="no-underline text-dark-700"
      to={`/mads/${mad.id}`}
      key={mad.id}
    >
      <FollowUpPlate mad={mad} user={user} />
    </Link>
  );
};

const CollaboratorFollowUpsSection: React.FC<CollaboratorFollowUpsSectionProps> = ({
  user,
}) => {
  const t = useTranslations();

  if (!user) {
    return null;
  }

  const ongoingMads = sortBy(
    concat(
      user.madsAsTalent.filter((e) => new Date(e.endDate) > new Date()),
      user.madsAsReferent.filter((e) => new Date(e.endDate) > new Date())
    ),
    (a) => a.updatedAt
  ).reverse();
  const finishedMads = sortBy(
    concat(
      user.madsAsTalent.filter((e) => new Date(e.endDate) <= new Date()),
      user.madsAsReferent.filter((e) => new Date(e.endDate) <= new Date())
    ),
    (a) => a.updatedAt
  ).reverse();

  return (
    <>
      {[
        { key: "ongoingFollowUps", values: ongoingMads },
        { key: "finishedFollowUps", values: finishedMads },
      ].map((mads) => (
        <div key={mads.key} className="pt-4" id={`followUpPlates-${mads.key}`}>
          <H4>{t(`collaborator.${mads.key}`)}</H4>
          <div className="pt-1">
            {mads.values.length === 0 ? (
              <div className="text-sm text-light-900">
                <p>{t("collaborator.noFollowUps")}</p>
              </div>
            ) : (
              mads.values.map((e) => getPlate(e, user))
            )}
          </div>
        </div>
      ))}
    </>
  );
};

export default CollaboratorFollowUpsSection;
